import { render } from "./flats-crm-prems.vue?vue&type=template&id=69246c76"
import script from "./flats-crm-prems.vue?vue&type=script&lang=js"
export * from "./flats-crm-prems.vue?vue&type=script&lang=js"

import "./flats-crm-prems.vue?vue&type=style&index=0&id=69246c76&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__